// ========== PRODUCT CONFIGURATOR V2 ==========
// Ce fichier contient toute la logique JavaScript pour la version v2 du configurateur
// Utilise les IDs avec suffixe V2 et V3

// Fonctions utilitaires (comme dans l'original)
function financial(x) {
    return parseFloat(x) / 100;
}

function boolean(x) {
    return x === 'true';
}

// Variables globales pour le prix et les dimensions (v2)
const configuratorBlockV2 = document.querySelector('.configurator-block');
const basePriceV2 = configuratorBlockV2 ? financial(configuratorBlockV2.dataset.basePrice) : 0;
const compareAtPriceV2 = configuratorBlockV2 ? financial(configuratorBlockV2.dataset.compareAtPrice) : 0;
const hasDiscountV2 = configuratorBlockV2 ? boolean(configuratorBlockV2.dataset.hasDiscount) : false;
const priceDisplayV2 = document.querySelectorAll('.calculatedPrice');

// Variables globales pour le cropper v2
var cropperV2 = null;
var imageV2 = document.querySelector('#cropperImageV2');

// Fonction pour mettre à jour le prix (v2)
function updatePriceV2() {
    const widthInputV2 = document.getElementById('customWidthV2');
    const heightInputV2 = document.getElementById('customHeightV2');

    if (!widthInputV2 || !heightInputV2 || !cropperV2) return;

    const baseWidth = parseFloat(widthInputV2.value);
    const baseHeight = parseFloat(heightInputV2.value);
    const width = baseWidth;
    const height = baseHeight;

    var currentBasePrice = basePriceV2;
    if (paperTypeAbTestV2()) {
        currentBasePrice += 10;
    }

    if (!isNaN(width) && !isNaN(height)) {
        cropperV2.setAspectRatio(width / height);

        if (width > height) {
            var new_height = cropperV2.getContainerData().width * (height / width);
            cropperV2.setCropBoxData({
                left: 0,
                top: (cropperV2.getContainerData().height / 2) - (new_height / 2),
                width: cropperV2.getContainerData().width,
                height: new_height
            });
        } else {
            var new_width = cropperV2.getContainerData().height * (width / height);
            cropperV2.setCropBoxData({
                left: (cropperV2.getContainerData().width / 2) - (new_width / 2),
                top: 0,
                width: new_width,
                height: cropperV2.getContainerData().height
            });
        }

        const totalArea = (baseWidth / 100) * (baseHeight / 100);
        const totalPrice = currentBasePrice * totalArea;

        var originalPrice = totalPrice;
        if (hasDiscountV2) {
            var originalPrice = compareAtPriceV2;
            if (typeof paperTypeAbTestV2 === 'function' && paperTypeAbTestV2()) {
                originalPrice += 10;
            }
            originalPrice *= totalArea;
        }

        priceDisplayV2.forEach(function (element) {
            console.log(element);
            if (hasDiscountV2) {
                element.innerHTML = '<span style="text-decoration: line-through;font-weight:normal;">' + originalPrice.toFixed(2) + '€</span> <span>' + totalPrice.toFixed(2) + '€';
            } else {
                element.textContent = totalPrice.toFixed(2) + '€';
            }
        });

        const scalapay_text_amount = document.getElementById('scalapay_text_amount_v2');
        if (scalapay_text_amount) {
            if (hasDiscountV2) {
                var difference = originalPrice.toFixed(2) - totalPrice.toFixed(2);
                scalapay_text_amount.innerHTML = '<b>DERNIÈRE CHANCE : Économisez ' + difference.toFixed(2) + '€ en passant commande aujourd\'hui !</b>';
            } else {
                scalapay_text_amount.innerHTML = 'ou 3 fois <b>' + (totalPrice / 3).toFixed(2) + '€</b> sans frais avec ';
            }
        }

        // Mettre à jour les barres avec les dimensions textuelles (v2)
        var top_width_bar = document.getElementById('top_width_bar_v2');
        var top_height_bar = document.getElementById('right_height_bar_v2');

        if (top_width_bar) {
            top_width_bar.innerHTML = width + 'cm';
        }
        if (top_height_bar) {
            top_height_bar.innerHTML = `<div id="returned_height_bar_number_v2">${height}cm</div>`;
        }
        if (top_width_bar && cropperV2) {
            top_width_bar.style.width = cropperV2.getCropBoxData().width + 'px';
        }
        if (top_height_bar && cropperV2) {
            top_height_bar.style.height = cropperV2.getCropBoxData().height + 'px';
        }

        if (top_width_bar && cropperV2) {
            top_width_bar.style.marginLeft = cropperV2.getCropBoxData().left + 'px';
        }
        if (top_height_bar && cropperV2) {
            top_height_bar.style.marginTop = cropperV2.getCropBoxData().top + 'px';
        }

        var returned_height_bar_number = document.getElementById('returned_height_bar_number_v2');
        if (returned_height_bar_number && cropperV2) {
            returned_height_bar_number.style.marginTop = (cropperV2.getCropBoxData().height / 2) - (returned_height_bar_number.offsetHeight / 2) + 'px';
        }

        // Calculate number of rolls and price per roll
        const rollWidthCm = 50;
        const numberOfRolls = Math.ceil(baseWidth / rollWidthCm);
        const pricePerRoll = totalPrice / numberOfRolls;

        // Update the roll delivery info (v2)
        const numberOfRollsEl = document.getElementById('numberOfRollsV2');
        const pricePerRollEl = document.getElementById('pricePerRollV2');
        if (numberOfRollsEl) {
            numberOfRollsEl.textContent = numberOfRolls;
        }
        if (pricePerRollEl) {
            pricePerRollEl.textContent = pricePerRoll.toFixed(2);
        }
    }
}

// Fonction pour mettre à jour seulement le prix (sans repositionner le crop) - v2
function updatePriceOnlyV2() {
    const widthInputV2 = document.getElementById('customWidthV2');
    const heightInputV2 = document.getElementById('customHeightV2');

    if (!widthInputV2 || !heightInputV2) return;

    const baseWidth = parseFloat(widthInputV2.value);
    const baseHeight = parseFloat(heightInputV2.value);

    var currentBasePrice = basePriceV2;
    if (paperTypeAbTestV2()) {
        currentBasePrice += 10;
    }

    if (!isNaN(baseWidth) && !isNaN(baseHeight)) {
        const totalArea = (baseWidth / 100) * (baseHeight / 100);
        const totalPrice = currentBasePrice * totalArea;

        var originalPrice = totalPrice;
        if (hasDiscountV2) {
            var originalPrice = compareAtPriceV2;
            if (typeof paperTypeAbTestV2 === 'function' && paperTypeAbTestV2()) {
                originalPrice += 10;
            }
            originalPrice *= totalArea;
        }

        priceDisplayV2.forEach(function (element) {
            if (hasDiscountV2) {
                element.innerHTML = '<span style="text-decoration: line-through;font-weight:normal;">' + originalPrice.toFixed(2) + '€</span> <span>' + totalPrice.toFixed(2) + '€';
            } else {
                element.textContent = totalPrice.toFixed(2) + '€';
            }
        });

        const scalapay_text_amount = document.getElementById('scalapay_text_amount_v2');
        if (scalapay_text_amount) {
            if (hasDiscountV2) {
                var difference = originalPrice.toFixed(2) - totalPrice.toFixed(2);
                scalapay_text_amount.innerHTML = '<b>DERNIÈRE CHANCE : Économisez ' + difference.toFixed(2) + '€ en passant commande aujourd\'hui !</b>';
            } else {
                scalapay_text_amount.innerHTML = 'ou 3 fois <b>' + (totalPrice / 3).toFixed(2) + '€</b> sans frais avec ';
            }
        }

        // Calculate number of rolls and price per roll
        const rollWidthCm = 50;
        const numberOfRolls = Math.ceil(baseWidth / rollWidthCm);
        const pricePerRoll = totalPrice / numberOfRolls;

        // Update the roll delivery info (v2)
        const numberOfRollsEl = document.getElementById('numberOfRolls');
        const pricePerRollEl = document.getElementById('pricePerRoll');
        if (numberOfRollsEl) {
            numberOfRollsEl.textContent = numberOfRolls;
        }
        if (pricePerRollEl) {
            pricePerRollEl.textContent = pricePerRoll.toFixed(2);
        }
    }
}

var show_resize_warning_v2 = () => {
    var cropping_table_resize_warning_box = document.querySelector('.cropping_table_resize_warning_box');

    if (cropping_table_resize_warning_box) {
        cropping_table_resize_warning_box.classList.add('show');

        setTimeout(function () {
            cropping_table_resize_warning_box.classList.add('show-bump');
        }, 500);

        setTimeout(function () {
            cropping_table_resize_warning_box.classList.remove('show', 'show-bump');
        }, 5000);
    }
};

// Fonction pour déterminer le type de papier sélectionné (A/B test) - déclarée globalement
function paperTypeAbTestV2() {
    // Vérifier d'abord la version v3
    const v3Block = document.querySelector('.paper-type-selector-v3');
    if (v3Block) {
        const computedStyle = window.getComputedStyle(v3Block);
        if (computedStyle.display !== 'none') {
            const stickyPaperV3 = document.getElementById('sticky-paper-v3');
            return stickyPaperV3 ? stickyPaperV3.checked : false;
        }
    }
}

window.addEventListener('DOMContentLoaded', function () {
    // Récupération des éléments du configurateur
    const configuratorBlock = document.querySelector('.configurator-block');
    const productTitle = configuratorBlock ? configuratorBlock.dataset.productTitle : '';

    // ========== FONCTION INIT INFO POPUP ==========
    function initInfoPopup(iconId, popupId) {
        const icon = document.getElementById(iconId);
        const popup = document.getElementById(popupId);

        if (!icon || !popup) return;

        const closeBtn = popup.querySelector('.info-popup-close');

        // Fonction pour détecter si on est sur mobile (dynamique)
        function isMobileDevice() {
            return window.matchMedia("(max-width: 768px)").matches;
        }

        // Détection initiale
        let isMobile = isMobileDevice();

        // Écouter les changements de taille d'écran (orientation, resize)
        const mediaQuery = window.matchMedia("(max-width: 768px)");
        mediaQuery.addEventListener('change', (e) => {
            isMobile = e.matches;
        });

        if (!isMobile) {
            // On larger screens: show the popup on hover, hide it on mouseout.
            icon.addEventListener('mouseenter', () => {
                popup.style.display = 'block';
            });
            icon.addEventListener('mouseleave', () => {
                popup.style.display = 'none';
            });
            popup.addEventListener('mouseenter', () => {
                popup.style.display = 'block';
            });
            popup.addEventListener('mouseleave', () => {
                popup.style.display = 'none';
            });
        }

        // On mobile (or fallback), use click to toggle show/hide
        icon.addEventListener('click', (e) => {
            // Prevent immediate "mouseleave" from closing it
            e.stopPropagation();
            if (popup.style.display === 'block') {
                popup.style.display = 'none';
            } else {
                popup.style.display = 'block';
            }
        });

        // Close button for mobile
        if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                popup.style.display = 'none';
            });
        }

        // Fermer la popup quand on clique en dehors sur mobile
        document.body.addEventListener('click', (ev) => {
            if (isMobile && popup.style.display === 'block') {
                // Si l'utilisateur clique en dehors de la popup et de l'icône
                if (!popup.contains(ev.target) && ev.target !== icon) {
                    popup.style.display = 'none';
                }
            }
        }, true);
    }

    // Initialisation des popups info pour toutes les versions
    initInfoPopup('infoIcon1v2', 'infoPopup1v2');
    initInfoPopup('infoIcon2v2', 'infoPopup2v2');
    initInfoPopup('infoIcon3v3', 'infoPopup3v3');

    // ========== GESTION DU STATUT DES ÉTAPES ==========

    // Fonction pour mettre à jour le statut de l'étape 1 (dimensions v2)
    function updateStepStatusV2() {
        const heightInput = document.getElementById('customHeightV2');
        const widthInput = document.getElementById('customWidthV2');
        const statusIcon = document.querySelector('.stepStatusIcon1v2');

        if (heightInput && widthInput && statusIcon) {
            const height = parseFloat(heightInput.value);
            const width = parseFloat(widthInput.value);

            // Vérifier si les deux champs sont remplis et valides
            // Ne pas considérer comme complété si les valeurs sont vides, invalides, ou égales à 0
            const isCompleted = !isNaN(height) && height > 0 && !isNaN(width) && width > 0 &&
                heightInput.value.trim() !== '' && widthInput.value.trim() !== '';

            if (isCompleted) {
                statusIcon.classList.add('step-completed');
            } else {
                statusIcon.classList.remove('step-completed');
            }
        }
    }

    // Écouter les changements sur les inputs v2
    const heightInputV2 = document.getElementById('customHeightV2');
    const widthInputV2 = document.getElementById('customWidthV2');
    const statusIcon1V2 = document.querySelector('.stepStatusIcon1v2');

    if (heightInputV2) {
        heightInputV2.addEventListener('input', function () {
            updateStepStatusV2();
            updatePriceV2();
            show_resize_warning_v2();
        });
        heightInputV2.addEventListener('blur', function () {
            updateStepStatusV2();
            updatePriceV2();
        });
    }

    if (widthInputV2) {
        widthInputV2.addEventListener('input', function () {
            updateStepStatusV2();
            updatePriceV2();
            show_resize_warning_v2();
        });
        widthInputV2.addEventListener('blur', function () {
            updateStepStatusV2();
            updatePriceV2();
        });
    }

    // Permettre de cliquer sur l'icône pour réinitialiser quand elle est complétée
    if (statusIcon1V2) {
        statusIcon1V2.addEventListener('click', function (e) {
            // Vérifier si l'étape est actuellement complétée
            if (statusIcon1V2.classList.contains('step-completed')) {
                // Réinitialiser les champs
                if (heightInputV2) {
                    heightInputV2.value = '';
                }
                if (widthInputV2) {
                    widthInputV2.value = '';
                }
                // Retirer immédiatement la classe completed pour forcer le retour à l'image
                statusIcon1V2.classList.remove('step-completed');
                // Mettre à jour le statut pour confirmer
                updateStepStatusV2();
                // Mettre le focus sur le premier champ
                if (heightInputV2) {
                    setTimeout(function () {
                        heightInputV2.focus();
                    }, 10);
                }
            }
        });
    }

    // Vérifier l'état initial (mais ne pas marquer comme complété si ce sont les valeurs par défaut)
    // On attend que l'utilisateur interagisse avec les champs
    const initialHeight = heightInputV2 ? parseFloat(heightInputV2.value) : 0;
    const initialWidth = widthInputV2 ? parseFloat(widthInputV2.value) : 0;

    // Si les valeurs sont les valeurs par défaut typiques (100), on considère comme non complété
    // jusqu'à ce que l'utilisateur modifie les valeurs
    if (initialHeight === 100 && initialWidth === 100) {
        if (statusIcon1V2) {
            statusIcon1V2.classList.remove('step-completed');
        }
    } else {
        updateStepStatusV2();
    }

    // Fonction pour mettre à jour le statut de l'étape 3 (sélecteur de type de papier v3)
    // Cette fonction ne doit marquer comme complété QUE si l'étape est fermée (complétée)
    // Elle ne doit pas marquer comme complété juste parce qu'un radio est sélectionné
    function updateStepStatusV3() {
        // Cette fonction est utilisée uniquement pour la validation lors de la sélection
        // Le statut "complété" est géré par completeStep() et les événements toggle des details
    }

    // Écouter les changements sur les radio buttons v3
    const premiumPaperV3 = document.getElementById('premium-paper-v3');
    const stickyPaperV3 = document.getElementById('sticky-paper-v3');
    const statusIconV3 = document.querySelector('.stepStatusIcon3v3');

    if (premiumPaperV3) {
        premiumPaperV3.addEventListener('change', function () {
            updateStepStatusV3();
            updatePriceOnlyV2();
        });
    }

    if (stickyPaperV3) {
        stickyPaperV3.addEventListener('change', function () {
            updateStepStatusV3();
            updatePriceOnlyV2();
        });
    }

    // Écouter les changements sur les radio buttons v2 (si présents)
    document.querySelectorAll('.paper-type-v3').forEach(function (element) {
        console.log(element);
        element.addEventListener('change', updatePriceOnlyV2);
    });

    // Permettre de cliquer sur l'icône pour réinitialiser quand elle est complétée (v3)
    if (statusIconV3) {
        statusIconV3.addEventListener('click', function (e) {
            // Vérifier si l'étape est actuellement complétée
            if (statusIconV3.classList.contains('step-completed')) {
                // Désélectionner tous les radio buttons
                if (premiumPaperV3) {
                    premiumPaperV3.checked = false;
                }
                if (stickyPaperV3) {
                    stickyPaperV3.checked = false;
                }
                // Retirer immédiatement la classe completed pour forcer le retour à l'image
                statusIconV3.classList.remove('step-completed');
            }
        });
    }

    // ========== SYSTÈME DE NAVIGATION ENTRE LES ÉTAPES ==========

    // Récupération du bouton CTA unique (remplace les boutons "Suivant" des étapes)
    const ctaButton = document.getElementById('cropperButtonV2');
    const ctaButtonText = document.getElementById('ctaButtonText');
    const ctaButtonTextWrapper = document.getElementById('ctaButtonTextWrapper');
    const addToCartBlock = document.querySelector('.add-to-cart-button-block');

    // Afficher le bloc CTA au départ (mais avec texte "Suivant")
    if (addToCartBlock) {
        addToCartBlock.style.display = 'block';
    }

    // Initialiser le bouton avec "Suivant"
    let currentStep = 1; // 1 = étape 1, 2 = étape 2, 3 = étape 3 (ajouter au panier)

    function updateCTAButton(step) {
        currentStep = step;
        if (!ctaButtonText || !ctaButton) return;

        // Récupérer les éléments du point et de la flèche
        const priceSeparator = ctaButtonTextWrapper.querySelector('.cta-price-separator');
        const arrowIcon = ctaButtonTextWrapper.querySelector('.cta-arrow-icon');
        const priceSpan = ctaButtonTextWrapper.querySelector('.calculatedPrice');

        if (step === 3) {
            // Étape 3 : Afficher "Ajouter au panier"
            ctaButtonText.textContent = 'Ajouter au panier';
            // Afficher le prix, le point et la flèche
            if (priceSpan) {
                priceSpan.style.display = 'inline';
            }
            if (priceSeparator) {
                priceSeparator.style.display = 'inline';
            }
            if (arrowIcon) {
                arrowIcon.style.display = 'inline-block';
            }
        } else {
            // Étapes 1 et 2 : Afficher "Suivant"
            ctaButtonText.textContent = 'Suivant';
            // Masquer le prix, le point et la flèche
            if (priceSpan) {
                priceSpan.style.display = 'none';
            }
            if (priceSeparator) {
                priceSeparator.style.display = 'none';
            }
            if (arrowIcon) {
                arrowIcon.style.display = 'none';
            }
        }
    }

    // Récupération des éléments des étapes
    const step1Details = document.querySelector('.configurator-step--size');
    const step2Details = document.querySelector('.configurator-step--crop');
    const step3Details = document.querySelector('.configurator-step--paper-type');

    // Fonction réutilisable pour gérer le comportement de modification d'étape
    // Définie ici pour être accessible partout
    function handleStepModification(stepNumber) {
        if (stepNumber === 1) {
            // Étape 1 : fermer les étapes supérieures et rouvrir l'étape 1
            if (step2Details) {
                step2Details.removeAttribute('open');
            }
            if (step3Details) {
                step3Details.removeAttribute('open');
            }
            reopenStep(1);
            updateCTAButton(1);
            updateCTAVisibility();
            updateModifyButtonsVisibility();
        } else if (stepNumber === 2) {
            // Étape 2 : fermer l'étape 3 et rouvrir l'étape 2
            if (step3Details) {
                step3Details.removeAttribute('open');
            }
            reopenStep(2);
            updateCTAButton(2);
            updateCTAVisibility();
            updateModifyButtonsVisibility();
        } else if (stepNumber === 3) {
            // Étape 3 : juste rouvrir l'étape 3
            reopenStep(3);
            updateCTAButton(3);
            updateCTAVisibility();
            updateModifyButtonsVisibility();
        }
    }

    // Gérer le clic sur les summary : permettre l'ouverture si étape complétée (comme les boutons Modifier)
    const allSummaries = document.querySelectorAll('.configurator-step__summary');
    allSummaries.forEach(function (summary) {
        const details = summary.closest('details');
        if (!details) return;

        // Identifier quelle étape c'est
        let stepNumber = null;
        if (details.classList.contains('configurator-step--size')) {
            stepNumber = 1;
        } else if (details.classList.contains('configurator-step--crop')) {
            stepNumber = 2;
        } else if (details.classList.contains('configurator-step--paper-type')) {
            stepNumber = 3;
        }

        summary.addEventListener('click', function (e) {
            // Vérifier si le clic est sur un élément interactif autorisé
            const target = e.target;
            // Vérifier plus précisément : soit la cible elle-même, soit un parent
            const isInfoIcon = target.classList.contains('info-icon') ||
                target.closest('.info-icon') ||
                (target.id && (target.id.startsWith('infoIcon')));
            const isInfoPopup = target.classList.contains('info-popup') ||
                target.closest('.info-popup') ||
                (target.id && (target.id.startsWith('infoPopup')));
            const isInfoPopupClose = target.classList.contains('info-popup-close') ||
                target.closest('.info-popup-close');

            // Si c'est un élément interactif autorisé, empêcher le toggle du details
            // MAIS ne pas empêcher la propagation pour que l'event listener de l'icon puisse fonctionner
            if (isInfoIcon || isInfoPopup || isInfoPopupClose) {
                e.preventDefault(); // Empêcher le comportement par défaut du summary
                // Ne pas appeler stopPropagation() pour permettre à l'event listener de l'icon de fonctionner
                return; // Laisser le clic se produire normalement pour la popup
            }

            // Vérifier si l'étape est complétée (icône avec step-completed)
            const statusIcon = summary.querySelector('.step-status-icon');
            const isStepCompleted = statusIcon && statusIcon.classList.contains('step-completed');

            if (isStepCompleted && stepNumber) {
                // Si l'étape est complétée, reproduire le comportement des boutons "Modifier"
                e.preventDefault();
                e.stopPropagation();
                handleStepModification(stepNumber);
            } else {
                // Si l'étape n'est pas complétée, empêcher le toggle
                e.preventDefault();
                e.stopPropagation();
                // Empêcher le toggle du details
                if (details.hasAttribute('open')) {
                    details.setAttribute('open', 'open');
                } else {
                    details.removeAttribute('open');
                }
            }
        }, true); // Utiliser la phase de capture pour intercepter l'événement avant qu'il ne remonte

        // Empêcher aussi le toggle via le clavier si l'étape n'est pas complétée
        summary.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                const statusIcon = summary.querySelector('.step-status-icon');
                const isStepCompleted = statusIcon && statusIcon.classList.contains('step-completed');

                if (!isStepCompleted) {
                    e.preventDefault();
                    e.stopPropagation();
                } else if (stepNumber) {
                    // Si complétée, déclencher le même comportement que le clic
                    e.preventDefault();
                    e.stopPropagation();
                    handleStepModification(stepNumber);
                }
            }
        });
    });

    const step1StatusIcon = document.querySelector('.stepStatusIcon1v2');
    const step2StatusIcon = document.querySelector('.stepStatusIcon2v2');
    const step3StatusIcon = document.querySelector('.stepStatusIcon3v3');

    const step1Recap = document.getElementById('step1Recap');
    const step1RecapText = document.getElementById('step1RecapText');
    const step2Recap = document.getElementById('step2Recap');
    const step2RecapText = document.getElementById('step2RecapText');
    const step3Recap = document.getElementById('step3Recap');
    const step3RecapText = document.getElementById('step3RecapText');

    const step2ModifyBtn = document.getElementById('step2ModifyBtn');
    const step3ModifyBtn = document.getElementById('step3ModifyBtn');

    // Gestionnaires de clic sur les recaps pour permettre la modification
    if (step1Recap) {
        step1Recap.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            // Vérifier que l'étape 1 est complétée (recap affiché)
            if (step1Recap.style.display !== 'none') {
                handleStepModification(1);
            }
        });
    }

    if (step2Recap) {
        step2Recap.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            // Vérifier que l'étape 2 est complétée (recap affiché)
            if (step2Recap.style.display !== 'none') {
                handleStepModification(2);
            }
        });
    }

    if (step3Recap) {
        step3Recap.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            // Vérifier que l'étape 3 est complétée (recap affiché)
            if (step3Recap.style.display !== 'none') {
                handleStepModification(3);
            }
        });
    }

    // Initialiser le bouton CTA
    updateCTAButton(1);

    // Initialiser la visibilité des boutons "Modifier"
    updateModifyButtonsVisibility();

    // Gestion de l'état des icônes selon l'ouverture/fermeture des details
    // Quand un details est ouvert, on retire step-completed pour afficher l'image "Not Done"
    // Le checkmark n'apparaît que si l'étape est fermée ET complétée (avec récap affiché)

    function updateIconOnToggle(details, statusIcon, recap) {
        if (!details || !statusIcon) return;

        details.addEventListener('toggle', function () {
            if (this.open) {
                // Si le details s'ouvre, toujours retirer step-completed pour afficher l'image "Not Done"
                statusIcon.classList.remove('step-completed');
            } else {
                // Si le details se ferme, vérifier si c'est une étape complétée (récap affiché)
                if (recap && recap.style.display !== 'none') {
                    // L'étape est complétée, ajouter step-completed pour afficher le checkmark
                    statusIcon.classList.add('step-completed');
                } else {
                    // L'étape n'est pas complétée, garder l'image "Not Done"
                    statusIcon.classList.remove('step-completed');
                }
            }
        });
    }

    // Appliquer la logique pour chaque étape
    updateIconOnToggle(step1Details, step1StatusIcon, step1Recap);
    updateIconOnToggle(step2Details, step2StatusIcon, step2Recap);
    updateIconOnToggle(step3Details, step3StatusIcon, step3Recap);

    // Initialiser l'état des icônes au chargement
    // Si un details est ouvert, l'icône doit montrer l'image "Not Done" (pas de step-completed)
    if (step1Details && step1Details.hasAttribute('open') && step1StatusIcon) {
        // Si le récap n'est pas affiché, ce n'est pas complété
        if (!step1Recap || step1Recap.style.display === 'none') {
            step1StatusIcon.classList.remove('step-completed');
        }
    }
    if (step2Details && step2Details.hasAttribute('open') && step2StatusIcon) {
        if (!step2Recap || step2Recap.style.display === 'none') {
            step2StatusIcon.classList.remove('step-completed');
        }
    }
    if (step3Details && step3Details.hasAttribute('open') && step3StatusIcon) {
        // Toujours retirer step-completed si step3 est ouvert au départ
        step3StatusIcon.classList.remove('step-completed');
    }

    // Fonction pour compléter une étape
    function completeStep(stepNumber) {
        let details, statusIcon, recap, recapText;

        if (stepNumber === 1) {
            details = step1Details;
            statusIcon = step1StatusIcon;
            recap = step1Recap;
            recapText = step1RecapText;
        } else if (stepNumber === 2) {
            details = step2Details;
            statusIcon = step2StatusIcon;
            recap = step2Recap;
            recapText = step2RecapText;
        }

        if (details && statusIcon) {
            // Marquer comme complété
            statusIcon.classList.add('step-completed');
            details.removeAttribute('open');

            // Afficher le récap
            if (stepNumber === 1) {
                const height = heightInputV2 ? heightInputV2.value : '';
                const width = widthInputV2 ? widthInputV2.value : '';
                if (height && width && recap && recapText) {
                    recapText.textContent = `🖼️ ${height}cm x ${width}cm`;
                    recap.style.display = 'block';
                }
            } else if (stepNumber === 2) {
                if (recap && recapText) {
                    recapText.textContent = '🖼️ Papier peint recadré';
                    recap.style.display = 'block';
                }
            }
        }
    }

    // Fonction pour rouvrir une étape (modification)
    function reopenStep(stepNumber) {
        let details, statusIcon, recap;

        if (stepNumber === 1) {
            details = step1Details;
            statusIcon = step1StatusIcon;
            recap = step1Recap;
        } else if (stepNumber === 2) {
            details = step2Details;
            statusIcon = step2StatusIcon;
            recap = step2Recap;
        } else if (stepNumber === 3) {
            details = step3Details;
            statusIcon = step3StatusIcon;
            recap = step3Recap;
        }

        if (details && statusIcon) {
            // Retirer le statut complété
            statusIcon.classList.remove('step-completed');
            details.setAttribute('open', 'open');

            // Masquer le récap
            if (recap) {
                recap.style.display = 'none';
            }
        }
    }

    // Gestion de la visibilité du bouton CTA selon l'étape
    function updateCTAVisibility() {
        if (!ctaButton || !addToCartBlock) return;

        if (currentStep === 1) {
            // Étape 1 : Afficher si les dimensions sont valides
            const height = heightInputV2 ? parseFloat(heightInputV2.value) : 0;
            const width = widthInputV2 ? parseFloat(widthInputV2.value) : 0;
            const isValid = !isNaN(height) && height > 0 && !isNaN(width) && width > 0 &&
                heightInputV2.value.trim() !== '' && widthInputV2.value.trim() !== '';
            addToCartBlock.style.display = isValid ? 'block' : 'none';
        } else {
            // Étapes 2 et 3 : Toujours afficher
            addToCartBlock.style.display = 'block';
        }
    }

    // Gestionnaire unique du bouton CTA pour toutes les étapes
    if (ctaButton) {
        ctaButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('Bouton CTA cliqué, currentStep:', currentStep);

            if (currentStep === 1) {
                // Étape 1 : Passer à l'étape 2
                completeStep(1);
                if (step2Details) {
                    step2Details.setAttribute('open', 'open');
                }
                updateCTAButton(2);
                updateCTAVisibility();
                updateModifyButtonsVisibility();
            } else if (currentStep === 2) {
                // Étape 2 : Passer à l'étape 3
                completeStep(2);
                if (step3Details) {
                    step3Details.setAttribute('open', 'open');
                }
                updateCTAButton(3);
                updateCTAVisibility();
                updateModifyButtonsVisibility();
            } else if (currentStep === 3) {
                // Étape 3 : Ajouter au panier

                // Récupérer les valeurs v2
                const heightV2 = heightInputV2 ? parseFloat(heightInputV2.value) : 0;
                const widthV2 = widthInputV2 ? parseFloat(widthInputV2.value) : 0;

                // Vérifications de validation
                if (!heightV2 || !widthV2 || heightV2 < 100 || heightV2 > 4000 || widthV2 < 100 || widthV2 > 6000) {
                    const errorBox = document.getElementById('add_to_cart_error_box_v2');
                    if (errorBox) {
                        errorBox.style.display = 'block';
                        if (heightV2 < 100 || heightV2 > 4000) {
                            errorBox.innerHTML = 'La hauteur de votre papier peint doit être comprise entre 100cm et 4 mètres.<br/>Si vous souhaitez un plus grand format veuillez nous contacter à <a href="mailto:info@lepapierpeint.fr" style="color:#2e2e2e;">info@lepapierpeint.fr</a>';
                        } else if (widthV2 < 100 || widthV2 > 6000) {
                            errorBox.innerHTML = 'La largeur de votre papier peint doit être comprise entre 100cm et 6 mètres.<br/>Si vous souhaitez un plus grand format veuillez nous contacter à <a href="mailto:info@lepapierpeint.fr" style="color:#2e2e2e;">info@lepapierpeint.fr</a>';
                        } else {
                            errorBox.innerHTML = 'Veuillez d\'abord renseigner les dimensions de votre papier peint.';
                        }
                    }
                    return;
                }

                // Récupérer l'instance du cropper v2 si elle existe
                const product_id = document.querySelector('.configurator-block')?.dataset.productId;

                // Utiliser l'instance globale du cropper v2 si disponible
                let cropBoxData = { x: 0, y: 0, width: 0, height: 0 };
                if (cropperV2) {
                    // Utiliser l'instance existante du cropper v2
                    const cropData = cropperV2.getData();
                    cropBoxData = {
                        x: cropData.x || 0,
                        y: cropData.y || 0,
                        width: cropData.width || 0,
                        height: cropData.height || 0
                    };
                } else if (typeof cropper !== 'undefined' && cropper) {
                    // Fallback vers l'instance globale cropper si disponible
                    const cropData = cropper.getData();
                    cropBoxData = {
                        x: cropData.x || 0,
                        y: cropData.y || 0,
                        width: cropData.width || 0,
                        height: cropData.height || 0
                    };
                }

                // Préparer les données pour localStorage
                const orderData = {
                    origin_url: cropperImageV2 ? cropperImageV2.src : '',
                    product_id: product_id,
                    width: widthV2.toString(),
                    height: heightV2.toString(),
                    sticky_paper: paperTypeAbTestV2(),
                    reverse_mode: document.getElementById('reverseModeV2') ? document.getElementById('reverseModeV2').checked : false,
                    crop_box: cropBoxData,
                    custom_metafields: {
                        'Dimensions': heightV2 + ' x ' + widthV2 + ' cm' + (document.getElementById('reverseModeV2')?.checked ? ' (miroir)' : ''),
                        'Type de papier': paperTypeAbTestV2() ? 'Autocollant' : 'Premium',
                        '_product_title': productTitle
                    }
                };

                // Store in localStorage
                localStorage.setItem('lepapierpeint_order_data', JSON.stringify(orderData));

                // Redirect immediately to loading page
                window.location.href = '/pages/chargement-de-votre-papier-peint';
            }
        });
    }

    // Écouter les changements sur les inputs étape 1 pour mettre à jour la visibilité du CTA
    if (heightInputV2) {
        heightInputV2.addEventListener('input', function () {
            updateStepStatusV2();
            updateCTAVisibility();
        });
        heightInputV2.addEventListener('blur', function () {
            updateStepStatusV2();
            updateCTAVisibility();
        });
    }

    if (widthInputV2) {
        widthInputV2.addEventListener('input', function () {
            updateStepStatusV2();
            updateCTAVisibility();
        });
        widthInputV2.addEventListener('blur', function () {
            updateStepStatusV2();
            updateCTAVisibility();
        });
    }

    // Fonction pour mettre à jour la visibilité des boutons "Modifier" selon l'étape
    function updateModifyButtonsVisibility() {
        const actionsContainer = document.querySelector('.configurator-step__actions');

        // Masquer tous les boutons par défaut
        if (step2ModifyBtn) step2ModifyBtn.style.display = 'none';
        if (step3ModifyBtn) step3ModifyBtn.style.display = 'none';

        // Afficher le bouton approprié selon l'étape
        let shouldShowContainer = false;
        if (currentStep === 2) {
            // Étape 2 : Afficher "Modifier mes mesures"
            if (step2ModifyBtn) {
                step2ModifyBtn.style.display = 'block';
                shouldShowContainer = true;
            }
        } else if (currentStep === 3) {
            // Étape 3 : Afficher seulement "Modifier mon recadrage"
            if (step3ModifyBtn) {
                step3ModifyBtn.style.display = 'block';
                shouldShowContainer = true;
            }
        }

        // Afficher ou masquer le conteneur parent
        if (actionsContainer) {
            if (shouldShowContainer) {
                actionsContainer.style.display = 'flex';
            } else {
                actionsContainer.style.display = 'none';
            }
        }
    }

    // Bouton "Modifier mes mesures" étape 2
    if (step2ModifyBtn) {
        step2ModifyBtn.addEventListener('click', function () {
            handleStepModification(1);
        });
    }

    // Bouton "Modifier mon recadrage" étape 3
    if (step3ModifyBtn) {
        step3ModifyBtn.addEventListener('click', function () {
            handleStepModification(2);
        });
    }

    // Vérifier l'état initial pour le bouton CTA
    updateCTAVisibility();

    // Gestion du mode miroir v2 (dans le DOMContentLoaded comme dans l'original)
    const reverseModeV2 = document.getElementById('reverseModeV2');
    if (reverseModeV2) {
        reverseModeV2.addEventListener('change', function () {
            if (cropperV2) {
                if (this.checked) {
                    cropperV2.scaleX(-1);
                } else {
                    cropperV2.scaleX(1);
                }
            }
        });
    }

    // Initialiser le cropper v2 seulement après que Cropper.js soit chargé
    // Vérifier que Cropper est disponible avant d'initialiser
    function initCropperWhenReady() {
        if (typeof Cropper !== 'undefined') {
            load_cropper_v2();
        } else {
            // Retry après un court délai
            setTimeout(initCropperWhenReady, 100);
        }
    }

    initCropperWhenReady();
});

// Déclaration de l'image et de la fonction en dehors du DOMContentLoaded (comme dans l'original)
var imageV2 = document.querySelector('#cropperImageV2');

function load_cropper_v2() {
    if (!imageV2) {
        console.warn('cropperImageV2 not found');
        return;
    }

    if (typeof Cropper === 'undefined') {
        console.error('Cropper.js library is not loaded');
        return;
    }

    console.log('Cropper v2 loaded');

    cropperV2 = new Cropper(imageV2, {
        autoCropArea: 1,
        viewMode: 1,
        movable: false,
        zoomable: false,
        zoomOnTouch: false,
        zoomOnWheel: false,
        restore: false,
        wheelZoomRatio: 0,
        rotatable: false,
        scalable: true,
        dragMode: 'move',
        modal: true,
        cropBoxResizable: false,
        cropBoxMovable: true,
        cropmove: function (event) {
            // Trouver le canvas dans le container de l'image v2
            const container = imageV2.parentElement;
            if (container) {
                const canvas = container.querySelector('.cropper-canvas');
                if (canvas) {
                    canvas.classList.add('copper-canvas-moving');
                }
            }

            // move bars v2 - exactement comme dans l'original
            var top_width_bar = document.getElementById('top_width_bar_v2');
            var top_height_bar = document.getElementById('right_height_bar_v2');

            console.log(top_width_bar);
            console.log(top_height_bar);

            console.log(cropperV2.getCropBoxData());

            if (top_height_bar) {
                top_height_bar.style.height = cropperV2.getCropBoxData().height + 'px';
            }

            if (top_width_bar) {
                top_width_bar.style.marginLeft = cropperV2.getCropBoxData().left + 'px';
            }

            if (top_height_bar) {
                top_height_bar.style.marginTop = cropperV2.getCropBoxData().top + 'px';
            }
        },
        cropend: function (event) {
            // Trouver le canvas dans le container de l'image v2
            const container = imageV2.parentElement;
            if (container) {
                const canvas = container.querySelector('.cropper-canvas');
                if (canvas) {
                    canvas.classList.remove('copper-canvas-moving');
                }
            }
        },
        ready: function () {
            console.log('Cropper v2 ready');
            updatePriceV2();
        }
    });
}
